<template>
  <div class="list-container">
    <entity-filter v-show="!showAdvancedFilter" :data-list="meas" :title="title" :searchable-fields="searchableFields" show-alphabetized-filter="false" :use-group="true" :group-by-options="groupByOptions" :actions="actions">
    </entity-filter>
    <generic-table v-show="!showAdvancedFilter" :title-map="titleMap" :table-body="meas" :end-point="endPoint"></generic-table>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment'
import { mapState } from 'vuex';
import { bus } from '../../main';
import AdvancedFilter from '../AdvancedFilter';
import EntityFilter from '../EntityFilter';
import GenericTable from '../GenericTable';
import store from '../../store.js';
import advancedSearchResults from '../advancedSearchResult';
import CreateButton from '../CreateButton';

export default {
  data() {
    return {
      title: {'icon': 'icon-mea', 'name': "Multilateral Environmental Agreements"},
      titleMap: {
      	'name': 'Name',
      	'abbreviation': 'Abbreviation',
      	'description': 'Description',
        'document': 'Document'
      },
      groupByOptions: {
      	'name': 'Name',
        'abbreviation': 'Abbreviation',
        'document': 'Document',
      },
      endPoint: '/meas/{{ id }}/details',
      searchableFields: ['name', 'abbreviation', 'indicator'],
      actions: [
        { 
          name: 'Add MEA', 
          url: "/meas/create",
          perm: "add_mea"
        }
      ],
      label: 'Loading'
    };
  },

  watch: {
      // call this method if the route changes
      '$route': 'fetchAllMeas'
  },
  
  mounted() {
    this.toggleSidebar();
  },

  computed:{
    ...mapState({
      meas: function(state) {
        let meas = state.meas;
        
        if (meas == undefined) 
          return meas;
          
        meas.forEach(function(mea) {
          let mou = mea.mou;
          let start_date = '--';
          let end_date = '--';
          
          if (mou != undefined) {
            start_date = (mou.start_date != null)? moment(mou.start_date).format('MMMM DD YYYY, hh:mm A') : '--';
            end_date = (mou.end_date != null)? moment(mou.end_date).format('MMMM DD YYYY, hh:mm A') : '--';
          }
          
          mea['start_date'] = start_date;
          mea['end_date'] = end_date;
        });
        
        return meas;
      },
        
      showAdvancedFilter: state => state.showAdvancedFilter,
      loading: state => state.loading
    }),
  },
  
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
  },
  
  beforeRouteEnter (to, from, next) {
    store.dispatch('resetErrors');
    store.dispatch('fetchMeas');
    next();
  },
  components:{
    GenericTable,
    EntityFilter,
    AdvancedFilter,
    advancedSearchResults,
    CreateButton
  }
};
</script>

<style lang="scss">
  h2{
    font-size: 1.25em;
    margin-bottom: 10px;
    margin-top: 10px;
  }
h1{
  height: 21px;
}
.list-container{
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/mea/MeaList.vue